import { render, staticRenderFns } from "./task-comment-activity-wrapper.vue?vue&type=template&id=79ca0c0b&scoped=true&"
import script from "./task-comment-activity-wrapper.vue?vue&type=script&lang=ts&"
export * from "./task-comment-activity-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./task-comment-activity-wrapper.vue?vue&type=style&index=0&id=79ca0c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca0c0b",
  null
  
)

export default component.exports